import {
  takeLatest, put, call, all,
} from 'redux-saga/effects';
import * as actions from '@actions';
import SecuritySetting from '@services/security-setting';
import { IdType } from '@rootCommon/types/common';
import OrganizationSecuritySetting, { OrganizationSecuritySettingDto } from '@rootCommon/types/orgSecuritySetting';

import { AxiosError } from 'axios';
import { SagaGenerator } from './index';

// fetch
function* fetchSecuritySettingAsync(action: { payload: IdType }) {
  try {
    const securitySetting: OrganizationSecuritySetting = yield call(SecuritySetting.getByOrgId, action.payload);

    yield put(actions.fetchSecuritySetting.success(securitySetting));
  } catch (e) {
    const error = e as AxiosError | Error;
    yield put(actions.fetchSecuritySetting.failure(error));
  }
}

function* watchFetchSecuritySetting() {
  yield takeLatest(actions.fetchSecuritySetting.request, fetchSecuritySettingAsync);
}

// update
function* updateSecuritySettingAsync(action: { payload: { id: IdType; data: OrganizationSecuritySettingDto } }) {
  try {
    const securitySetting: OrganizationSecuritySetting = yield call(
      SecuritySetting.update,
      action.payload.id,
      action.payload.data,
    );

    yield put(actions.updateSecuritySetting.success(securitySetting));
  } catch (e) {
    const error = e as AxiosError | Error;
    yield put(actions.updateSecuritySetting.failure(error));
  }
}

function* watchUpdateSecuritySetting() {
  yield takeLatest(actions.updateSecuritySetting.request, updateSecuritySettingAsync);
}

// all
function* watchSecuritySetting(): SagaGenerator {
  yield all([watchFetchSecuritySetting(), watchUpdateSecuritySetting()]);
}

export default watchSecuritySetting;
